export default __webpack_public_path__ + "static/media/cloudnoon.a015e132.jpg";